import App from 'app/app.js';

function StatsdService($http) {
  var countStat = function (code) {
    return $http.post('stats/count/' + code);
  };

  // this is a fire and forget call
  this.logPageLoadTime = function (loadTimeInMills) {
    $http.post('stats/recordLoadTime', { loadTime: loadTimeInMills });
  };

  this.logImageRenderFailureTime = function (loadTimeInMills) {
    $http.post('stats/recordRenderFailureTime', { loadTime: loadTimeInMills });
  };

  this.logImageRenderSuccessTime = function (loadTimeInMills) {
    $http.post('stats/recordRenderSuccessTime', { loadTime: loadTimeInMills });
  };

  this.logSmartLink = function (source) {
    var code = 'SMART_LINK';
    if (!!source) {
      code = code + '_' + source.toUpperCase();
    }
    return countStat(code);
  };

  this.logSmartLinkFailure = function (source) {
    var code = 'SMART_LINK_FAILURE';
    if (!!source) {
      code = code + '_' + source.toUpperCase();
    }
    return countStat(code);
  };

  this.incrementCounter = function (counterName) {
    return countStat(counterName);
  };

  this.logOrderCreationTime = function (orderCreationTimeInMills) {
    $http.post('stats/recordOrderCreationTime', { orderCreationTime: orderCreationTimeInMills });
  };
}

App.service('StatsdService', ['$http', StatsdService]);
